// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"869aa7b0","360":"c079e5d4","629":"289d7a23","737":"2960e88c","858":"8ec48de9","934":"bbb3812e","958":"39a0930c"}[chunkId] + ".chunk.js";
};